const getTitles = (level, titleText) => {
    let titlePre = 'Main living room',
        title = `${titleText}`;

    switch (parseInt(level, 10)) {
        case 2:
            titlePre = 'Additional level 1';
            title = `${titleText}`;
            break;
        case 3:
            titlePre = 'Additional level 2';
            title = `${titleText}`;
            break;
        default:
            break;
    }

    return {
        titlePre,
        title
    };
};

export default getTitles;
